import type { Building, Citizen, EconomyState, Vehicle } from '../../types/core';
import { getBuildingDefinition } from '../../world/buildingDefinitions';

export function updateEconomy(
  economy: EconomyState,
  buildings: readonly Building[],
  citizens: readonly Citizen[],
  vehicles: readonly Vehicle[],
  deltaMinutes: number
): EconomyState {
  const completed = buildings.filter((building) => building.stage === 'completed');
  const commerce = completed.filter((building) => building.zone === 'commercial');
  const workspaces = completed.filter((building) => building.zone === 'workspace');
  const parks = completed.filter((building) => building.zone === 'park');
  const population = citizens.length;
  const dailyTax = population * 5.5;
  const dailyCommerce = commerce.reduce((sum, building) => sum + building.popularity * 0.55, 0);
  const dailyProduction = workspaces.reduce((sum, building) => sum + getBuildingDefinition(building.kind).jobs * 2.2, 0);
  const dailyTourism = Math.round((parks.length * 8 + commerce.length * 5) * Math.max(1, population / 40));
  const dailyMaintenance =
    buildings.reduce((sum, building) => sum + getBuildingDefinition(building.kind).baseCost * 0.012, 0) +
    vehicles.length * 3.5;
  const incomePerDay = Math.round(dailyTax + dailyCommerce + dailyProduction + dailyTourism);
  const expensesPerDay = Math.round(dailyMaintenance);
  const netPerMinute = (incomePerDay - expensesPerDay) / 1440;

  return {
    credits: Math.round((economy.credits + netPerMinute * deltaMinutes) * 100) / 100,
    incomePerDay,
    expensesPerDay,
    tourism: Math.round(dailyTourism),
    maintenance: Math.round(dailyMaintenance)
  };
}
